"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function BlogError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    try {
      Sentry.captureException(error);
    } catch {
      // Reporting must not prevent the visitor from retrying.
    }
  }, [error]);

  return (
    <main
      id="main"
      tabIndex={-1}
      className="mx-auto max-w-xl py-24 text-center"
    >
      <h1 className="text-3xl font-bold mb-6">Blog temporarily unavailable</h1>
      <p className="text-sm text-gray-500">
        We could not load this page. Please try again.
      </p>
      <button
        type="button"
        onClick={reset}
        className="mt-6 rounded bg-blue-600 px-4 py-2 text-white"
      >
        Try again
      </button>
    </main>
  );
}
